import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdArticle, MdDashboard, MdEditSquare, MdLibraryBooks, MdMenu, MdClose, MdSportsEsports } from 'react-icons/md';

const NAV_LINKS = [
  { to: '/blogs', icon: MdLibraryBooks, label: 'All Blogs' },
  { to: '/blogs/write', icon: MdEditSquare, label: 'Write Blog' },
  { to: '/my-blogs', icon: MdArticle, label: 'My Blogs' },
  { to: '/practice-arena', icon: MdSportsEsports, label: 'Practice Arena' },
  { to: '/dashboard', icon: MdDashboard, label: 'Dashboard' }
];

const BlogNavbar = ({ title, subtitle }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="mx-auto max-w-7xl px-3 pb-0 pt-3 sm:px-4 sm:pt-5 lg:px-8 lg:pt-6">
      <div className="mb-4 rounded-[30px] border border-gray-100 bg-white p-3 shadow-sm sm:mb-4 sm:p-5 lg:p-7">

        <div className="flex items-center justify-between gap-3">

          {/* Hamburger - Mobile Left */}
          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="flex h-9 w-9 items-center justify-center rounded-lg hover:bg-gray-100 sm:hidden"
          >
            <MdMenu className="h-6 w-6 text-gray-900" />
          </button>

          {/* Logo + Title */}
          <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
            <img
              src="/favicon.png"
              alt="Logo"
              className="h-10 w-10 shrink-0 object-contain sm:h-14 sm:w-14 lg:h-16 lg:w-16"
            />
            <div className="min-w-0">
              <h1 className="bg-gradient-to-r from-purple-600 to-orange-500 bg-clip-text text-base font-bold leading-normal text-transparent sm:text-xl lg:text-2xl">
                {title}
              </h1>
              <p className="text-xs font-medium text-gray-500 sm:text-sm">
                {subtitle}
              </p>
            </div>
          </div>

          {/* Desktop Nav Links */}
          <div className="hidden items-center gap-2 sm:flex">
            {NAV_LINKS.map(({ to, icon: Icon, label }) => {
              const isActive = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  className={`flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-medium text-white shadow-sm transition-all duration-200 hover:scale-105 hover:shadow-md lg:px-4 lg:text-sm ${
                    isActive ? 'ring-2 ring-white/60 ring-offset-1' : ''
                  }`}
                  style={{ background: 'linear-gradient(135deg, #9a51a0, #f36f21)' }}
                >
                  <Icon className="h-3.5 w-3.5 shrink-0 lg:h-4 lg:w-4" />
                  {label}
                </Link>
              );
            })}
          </div>

        </div>
      </div>

      {/* Mobile Drawer - Left Side, Tutorial Style */}
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity duration-300 sm:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Drawer */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-72 overflow-y-auto bg-white shadow-2xl transition-transform duration-300 ease-in-out sm:hidden ${
          menuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between border-b border-gray-200 p-4">
          <div>
            <span className="font-bold text-lg text-gray-900">Blog Navigation</span>
            <p className="mt-0.5 text-xs text-gray-500">Browse and switch sections</p>
          </div>
          <button
            type="button"
            onClick={() => setMenuOpen(false)}
            className="rounded-lg p-2 hover:bg-gray-100"
          >
            <MdClose className="h-6 w-6 text-gray-900" />
          </button>
        </div>

        {/* Drawer Nav Links */}
        <div className="p-4">
          <p className="mb-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-400">
            Navigation
          </p>
          <nav className="grid grid-cols-2 gap-2">
            {NAV_LINKS.map(({ to, icon: Icon, label }) => {
              const isActive = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center justify-center gap-1.5 rounded-lg px-3 py-2.5 text-xs font-medium text-white shadow-md transition-all ${
                    isActive ? 'ring-2 ring-white/60 ring-offset-1' : ''
                  }`}
                  style={{ background: 'linear-gradient(135deg, #9a51a0, #f36f21)' }}
                >
                  <Icon className="h-3.5 w-3.5 shrink-0" />
                  {label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default BlogNavbar;
